import { render, staticRenderFns } from "./AddBusinessProfileFailureReason.vue?vue&type=template&id=6b3c5a44&"
import script from "./AddBusinessProfileFailureReason.vue?vue&type=script&lang=js&"
export * from "./AddBusinessProfileFailureReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports